<!--
  ~ Copyright (c) 2022.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="page-heading">
  <br>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/home"><em class="la la-home font-20"></em></a>
    </li>
    <li class="breadcrumb-item">
      <span i18n="@@removal">Removal</span>
    </li>
  </ol>
</div>

<div class="page-content fade-in-up">
  <div class="jumbotron">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4 text-justify">
        <h3 i18n="@@removalRequest">Removal request</h3>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify">
        <p i18n="@@removalRequestInfo">The removal can take place as soon as the request is validated.</p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify">
        <u>
          <p i18n="@@removalRequestInfoOutside">
            Thank you to provide the animal corpse, outside buildings, in a non-hazardous area (power line, phone, rough
            terrain ....).
          </p>
        </u>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify">
        <p i18n="@@removalRequestInfoComments">
          You can provide details on the place of removal for example in comments.
        </p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify">
        <p i18n="@@phoneNumberInfo">
          The phone number must start with the country code. Ex: +33xxxxxxxxx, +41xxxxxxxxx
        </p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify">
        <p i18n="@@removalHelp">
          When the animal details inserted, clic on + buton to add it. Once all animals added in the tab, clic on
          "submit" button then validate the summary screen.
        </p>
      </div>

    </div>
  </div>

  <!-- TODO START remove me when transfer to Secanim is finished  -->
  <app-provalt-banner-collectable></app-provalt-banner-collectable>
  <!-- TODO End remove me when transfer to Secanim is finished  -->

  <div class="ibox">
    <div class="ibox-head">
      <div class="ibox-title" i18n="@@yourRemovalRequest">Your removal request</div>
    </div>

    <div class="ibox-body">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4">

        <form [formGroup]="removalFG" #removalForm="ngForm" (ngSubmit)="removalFormSubmit()">
          <div class="row">
            <div class=" col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
              <app-select-third-parties controlName="thirdParty" [formGroup]="removalFG"
                                        [submitted]="removalForm?.submitted"
                                        (updated)="tpChange($event)"></app-select-third-parties>

              <div class="row mt-4" *ngIf="hq">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <app-display-removal-point-details [data]="hq"></app-display-removal-point-details>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
                      <app-input-phone-numbers [removalPoint]="hq" [allowAdd]="true" [allowRemove]="true"
                                               (updated)="phonesChange($event, true)"></app-input-phone-numbers>
                    </div>

                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <app-input-phone-numbers [removalPoint]="hq" [allowAdd]="true" [allowRemove]="true"
                                               [mobilePhones]="true" (updated)="phonesChange($event, true)">
                      </app-input-phone-numbers>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3" *ngIf="sThirdParty">
              <app-select-removal-points controlName="removalPoint" [formGroup]="removalFG"
                                         [showManage]="null !== sThirdParty" [submitted]="removalForm?.submitted"
                                         [thirdParty]="sThirdParty" (updated)="rpChange($event)">
              </app-select-removal-points>

              <div class="row mt-4" *ngIf="sRemovalPoint">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <app-display-removal-point-details [data]="sRemovalPoint" [fontBold]="true">
                  </app-display-removal-point-details>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
                      <app-input-phone-numbers [removalPoint]="sRemovalPoint" [allowAdd]="true" [allowRemove]="true"
                                               (updated)="phonesChange($event, false)"></app-input-phone-numbers>
                    </div>

                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <app-input-phone-numbers [removalPoint]="sRemovalPoint" [allowAdd]="true" [allowRemove]="true"
                                               [mobilePhones]="true" (updated)="phonesChange($event, false)">
                      </app-input-phone-numbers>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="row mb-3" *ngIf="removalPointFC?.value">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <app-table-removal-animals controlName="animals" [formGroup]="removalFG"
                                         [submitted]="removalForm?.submitted"></app-table-removal-animals>
            </div>
          </div>


                <div class="row mb-3" *ngIf="removalPointFC?.value">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <app-input-comments controlName="comments" [showLabel]="true" [formGroup]="removalFG"
                                        [submitted]="removalForm?.submitted"></app-input-comments>
                  </div>
                </div>

                <div class="row mb-3" *ngIf="removalPointFC?.value">
                  <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                    <button type="submit" class="btn btn-success btn-rounded btn-block" i18n="@@submit"
                            [disabled]="true === removalFG?.invalid">
                      Submit
                    </button>
                  </div>
                </div>


        </form>

      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="removalPointFC?.value">
        <form [formGroup]="animalFG" #animalForm="ngForm" (ngSubmit)="animalFormSubmit()">

          <div class="row mb-3">
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <app-select-animal-species controlName="animalSpecies" [formGroup]="animalFG"
                                         [submitted]="animalForm?.submitted"
                                         (updated)="animalSpeciesChange($event)"></app-select-animal-species>
            </div>

            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
              <app-select-animal-categories controlName="animalCategory" [animalSpecies]="sAnimalSpecies"
                                            [formGroup]="animalFG" [submitted]="animalForm?.submitted"
                                            (updated)="animalCategoryChange($event)"></app-select-animal-categories>
            </div>

            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" *ngIf="showAnimalGender">
              <app-select-animal-genders controlName="animalGender" [formGroup]="animalFG"
                                         [submitted]="animalForm?.submitted" (updated)="updateAnimalDetail()">
              </app-select-animal-genders>
            </div>

            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" *ngIf="showAnimalType">
              <app-select-animal-types controlName="animalType" [formGroup]="animalFG"
                                       [submitted]="animalForm?.submitted" (updated)="updateAnimalDetail()">
              </app-select-animal-types>
            </div>

            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" *ngIf="showQuantity">
              <app-input-quantity controlName="quantity" [formGroup]="animalFG" [min]="1" [readonly]="rOQty"
                                  [submitted]="animalForm?.submitted" (updated)="updateValidators()">
              </app-input-quantity>
            </div>

            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" *ngIf="showWeight">
              <app-input-weight controlName="weight" [formGroup]="animalFG" [min]="1"
                                [submitted]="animalForm?.submitted"></app-input-weight>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" *ngIf="showCountry">
              <app-select-countries controlName="country" [formGroup]="animalFG" [submitted]="animalForm?.submitted"
                                    (updated)="countryChange($event)"></app-select-countries>
            </div>

            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" *ngIf="showAnimalNumber">
              <app-input-animal-number controlName="number" [animalDetail]="sAnimalDetail" [formGroup]="animalFG"
                                       showValidation="always"
                                       [submitted]="animalForm?.submitted"></app-input-animal-number>
            </div>

            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="showAnimalNumberSplit">
              <app-input-animal-number-split controlName="number" [animalDetail]="sAnimalDetail" [formGroup]="animalFG"
                                             [submitted]="animalForm?.submitted">
              </app-input-animal-number-split>
            </div>

            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" *ngIf="showAutopsy">
              <app-select-autopsies controlName="autopsy" [formGroup]="animalFG" [submitted]="animalForm?.submitted"
                                    (updated)="autopsyChange($event)"></app-select-autopsies>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="showCSO">
              <app-display-third-party-cso></app-display-third-party-cso>
            </div>

            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" *ngIf="showCSO"></div>
            <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10" *ngIf="!showCSO"></div>

            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"  *ngIf="sAnimalDetail">
              <button id="addButton" type="submit" class="btn btn-success btn-rounded btn-block" i18n="@@add">Add
              </button>
            </div>

          </div>

        </form>
      </div>
    </div>
  </div>
</div>
